var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',_vm._b({attrs:{"color":"transparent"}},'v-footer',_vm.$attrs,false),[_c('p',{staticClass:"text-center mx-auto mb-0",class:{
      'white--text onSmall': _vm.$vuetify.breakpoint.smAndDown && _vm.$route.name === 'auth',
      'body-2 grey--text text--darken-1': !(
        _vm.$vuetify.breakpoint.smAndDown && _vm.$route.name === 'auth'
      ),
    },style:(_vm.white ? 'color: white !important;' : '')},[_vm._v(" All Right Reserved Arches Language School ©2021 ")])])}
var staticRenderFns = []

export { render, staticRenderFns }